import { useState } from "react";

export const useImageUpload = () => {
  const [image, setImage] = useState(null);

  const handlePhotoFileUpdate = (fileItems) => {
    setImage(fileItems.length > 0 ? fileItems[0].file : null);
  };

  return { image, handlePhotoFileUpdate };
};
